import {Injectable} from "@angular/core";

import {DestroyingComponent} from "../abstract/destroying-component/destroying-component";

/**
 * @deprecated Alias storico di {@link DestroyingComponent} (base canonica per il teardown delle
 * subscription). Mantenuto solo per non toccare i sottoscrittori esistenti: il nuovo codice
 * estende direttamente `DestroyingComponent`. Espone lo stesso `destroy$` (`Subject<void>`),
 * usato con `takeUntil(this.destroy$)`.
 */
@Injectable()
export class UnsubscribeOnDestroy extends DestroyingComponent {}
